/**
=========================================================
* Material Dashboard 2 React - v2.2.0
=========================================================

* Product Page: https://www.creative-tim.com/product/material-dashboard-react
* Copyright 2023 Creative Tim (https://www.creative-tim.com)

Coded by www.creative-tim.com

 =========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.
*/

// @mui material components
import Grid from "@mui/material/Grid";
import Card from "@mui/material/Card";
import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";
import Layout from "components/LayoutContainers/mainLayout";
import { GeneralFetch } from "Api/generalFetch/generalFetch";
import LinearProgressComponent from "components/linearProgress/linearProgress";
import { useEffect, useState } from "react";
import Input from "components/fields/Input/Input";
import { Button, Popconfirm, Switch } from 'antd';
import { Accordion, AccordionDetails, IconButton } from "@mui/material";
import Selects from "components/fields/select/selectInput";
import { locais } from "constants/common/formConstants";
import EditIcon from '@mui/icons-material/Edit';
import Bill from "layouts/billing/components/Bill";
import Enrollment from "layouts/enrollment/newEnrollment";
import NewSearchSelect from "components/serachSelect/newSearchSelected";

function Settings() {
    const [loading, setLoading] = useState(false)
    const [formData, setFormData] = useState(false)
    const [loadingRemove, setLoadingRemove] = useState(false)
    const [options, setOptions] = useState()
    const [expanded, setExpanded] = useState({})
    const [disabled, setDisabled] = useState({})
    const [loadingUpdate, setLoadingUpdate] = useState({})
    const { fetchData } = GeneralFetch()
    const [open, setOpen] = useState(false);

    const fetchDataAsync = async () => {
        await fetchData({}, 'userList', 'get', 'users').then((data) => {
            const updated = data?.users?.map((user) => { return { label: user.name, value: user.id, local: user.local_id, acesso: JSON.parse(user.acesso) } })
            setOptions(updated)
            setLoading(false)
        })
    }

    const fetchDatasFecho = async () => {
        await fetchData({}, 'getConfig', 'get', 'data').then((data) => {
            setFormData(data?.data?.[0])
        })
    }

    const updateDataFecho = async (id) => {
        setLoadingUpdate({ [id]: true })
        await fetchData({ class: id, days: formData?.[id] }, 'updateConfig', 'put', '').then((data) => {
            setLoadingUpdate(false)
            setDisabled(prev => ({ ...prev, [id]: null }))
        })
    }

    const updateNotifications = async (response) => {
        setLoadingUpdate({ update: true })
        await fetchData({ receive: response == true ? 1 : 0 }, `notificationUpdate/${sessionStorage.getItem('uId')}`, 'put', '').then((data) => {
            sessionStorage.setItem('receiveAllNotifications', response == true ? 1 : 0)
            setLoadingUpdate({ update: false })
        })
    }

    useEffect(() => {
        setLoading(true)
        void fetchDataAsync()
        void fetchDatasFecho()
    }, [])

    async function roleUpdater(id, acesso, local) {
        setLoadingRemove(true)
        await fetchData({ acesso: acesso, local_id: local }, `roleUpdate/${id}`, 'put', '').then(() => {
            setLoadingRemove(false)
            setExpanded({})
            fetchDataAsync()
        })
    }

    function formatClassName(str) {
        return str.replace(/([a-z])([A-Z])/g, '$1 $2')
            .replace(/^./, (match) => match.toUpperCase());
    }

    const Btns = ({ keyy }) => {
        return (
            <div style={{ margin: "4px 0 0 0px" }} >
                <Button onClick={() => setDisabled(prev => ({ ...prev, [keyy]: true }))} style={{ fontWeight: "500" }} color="danger" variant="filled">
                    Edit
                </Button>
                <Popconfirm
                    title="Tem certeza?"
                    description={`Actualizar as a ${formatClassName(keyy)} ?`}
                    onConfirm={async () => await updateDataFecho(keyy)}
                    onCancel={() => setDisabled(prev => ({ ...prev, [keyy]: null }))}
                    okText="Sim"
                    cancelText="Não"
                >
                    <Button loading={loadingUpdate?.[keyy] == true} style={{ marginLeft: "5px", fontWeight: "500" }} color="primary" variant="filled">
                        Save
                    </Button>
                </Popconfirm>
            </div>
        )
    }

    return (
        <Layout>
            <Grid container marginTop={"0px"} spacing={6}>
                <Grid item xs={12}>
                    <MDBox
                        mx={2}
                        mt={-3}
                        py={0}
                        px={0}
                        variant="gradient"
                        bgColor="info"
                        borderRadius="lg"
                        coloredShadow="info"
                    >
                        {(loading || loadingRemove) && <LinearProgressComponent />}
                        <div style={{ width: "100%", height: "55px", display: "flex", alignItems: "center" }} >
                            <MDTypography variant="h6" color="white" marginLeft="20px" >
                                Configurações
                            </MDTypography>
                        </div>
                    </MDBox>

                    <MDBox p={3} pb={0}>
                        <MDTypography variant="h6" color="dark" style={{ marginTop: "5px", marginBottom: "10px" }}>
                            Gestão de utilizadores
                        </MDTypography>

                        <div style={{ display: 'inline-block', float: "left" }} >
                            <Enrollment />
                        </div>

                        <div style={{ display: 'inline-block', float: "left", marginLeft: "10px" }} >
                            <NewSearchSelect open={open} setOpen={setOpen} />
                        </div>
                    </MDBox>

                    <MDBox p={3} pb={0}>

                        {!open &&
                            <MDTypography variant="h6" color="dark" style={{ marginTop: "30px", marginBottom: "10px", transition: "margin-top 0.3s ease-in-out" }}>
                                Dias de fecho após o reporte
                            </MDTypography>
                        }
                        <div style={{
                            marginTop: open ? "20px" : "0",
                            width: "100%",
                            display: "grid",
                            gridTemplateColumns: "350px 350px 350px",
                            gap: "30px",
                            filter: open ? "blur(4px)" : "none",
                            pointerEvents: open ? "none" : "auto",
                            transition: "filter 0.3s ease-in-out"
                        }} >
                            {
                                Object?.keys?.(formData).map((key) => {
                                    return (
                                        <Card style={{ padding: "5px 10px", borderRadius: "6px" }} >
                                            <MDTypography variant="h6" color="secondary">
                                                {formatClassName(key)}
                                            </MDTypography>
                                            <Input
                                                type="number"
                                                placeholder="Dias"
                                                onChange={(_, val) => setFormData(prev => ({ ...prev, [key]: val }))}
                                                disabled={disabled?.[key] ? false : true}
                                                value={Number(formData?.[key])}
                                            />
                                            <Btns keyy={key} />
                                        </Card>
                                    )
                                })
                            }
                        </div>
                    </MDBox>

                    <MDBox p={3} pb={0} style={{
                        filter: open ? "blur(4px)" : "none",
                        pointerEvents: open ? "none" : "auto",
                        transition: "filter 0.3s ease-in-out"
                    }}>
                        <MDTypography variant="h6" color="dark" style={{ marginTop: "5px", marginBottom: "10px" }}>
                            Notificações
                        </MDTypography>
                        <div style={{ width: "100%", display: "grid", gridTemplateColumns: "1110px 0%", gap: "30px" }} >
                            <Card style={{ padding: "10px 10px", borderRadius: "6px" }} >
                                <div style={{ display: "grid", gridTemplateColumns: "90% 7%" }} >
                                    <MDTypography variant="h6" color="secondary">
                                        Receber notifições sobre todos os eventos registados nos meus sites
                                    </MDTypography>
                                    <Switch value={sessionStorage.getItem('receiveAllNotifications') == 1 ? true : false} loading={loadingUpdate?.update} onChange={(e) => updateNotifications(e)} style={{ marginTop: "3px" }} checkedChildren="Sim" unCheckedChildren="Não" />
                                </div>
                            </Card>
                        </div>
                    </MDBox>

                    <MDBox p={3} style={{
                        filter: open ? "blur(4px)" : "none",
                        pointerEvents: open ? "none" : "auto",
                        transition: "filter 0.3s ease-in-out"
                    }}>
                        <MDTypography variant="h6" color="dark" style={{ marginTop: "5px", marginBottom: "10px" }}>
                            Sites admin
                        </MDTypography>
                        <div style={{
                            width: "100%",
                            display: "grid",
                            gridTemplateColumns: "repeat(auto-fill, minmax(350px, max-content))",
                            gap: "30px",
                            justifyContent: "start",
                            alignItems: "start"
                        }} >
                            {locais?.map((location) => {
                                return (
                                    <Card style={{ padding: "5px 10px", borderRadius: "6px" }} >
                                        <div style={{ display: "flex", justifyContent: "space-between" }} >
                                            <MDTypography variant="h6" color="secondary">
                                                {location.label}
                                            </MDTypography>
                                            <IconButton onClick={() => setExpanded(prev => ({ ...prev, [location.label]: !!!prev?.[location.label] }))} style={{ margin: "-5px 5px -5px 0" }} >
                                                <EditIcon style={{ color: "#3891ED" }} />
                                            </IconButton>
                                        </div>

                                        <Accordion style={{ position: expanded?.[location?.label] ? "relative" : "absolute", marginTop: "5px" }} elevation={0} expanded={expanded?.[location?.label]} >
                                            <AccordionDetails style={{ margin: "-13px" }} >
                                                {expanded?.[location?.label] && <>
                                                    <div style={{ marginBottom: "10px" }} >
                                                        <MDTypography fontWeight="regular" fontSize="15px" variant="h6" color="dark">
                                                            Users
                                                        </MDTypography>
                                                    </div>
                                                    <Selects
                                                        fieldId="options"
                                                        options={options?.filter(x => x.acesso == '1')}
                                                        label="Users"
                                                        onChange={async (_, value) => {
                                                            roleUpdater(value, '2', location.value)
                                                        }}
                                                    />
                                                </>
                                                }
                                            </AccordionDetails>
                                        </Accordion>

                                        <MDBox component="ul" display="flex" flexDirection="column" p={0} m={0}>
                                            {
                                                options?.filter(x => x.local == location.value && x.acesso == '2')?.map((x) => <Bill
                                                    name={x.label}
                                                    onClick={() => roleUpdater(x.value, '1', location.value)}
                                                />)
                                            }
                                        </MDBox>
                                    </Card>
                                )
                            })}
                        </div>
                    </MDBox>
                </Grid>
            </Grid>
        </Layout>
    );
}

export default Settings;
